import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
const LotByItemSubTab = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const childRef = useRef();
    const allowedPageSizes = [25, 50, 100, 500, 1000, "all"];
    const gridKey = "E59EAFB0-AF9C-4776-82CC-C9799FD2460F";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
        }
    };

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <ColumnHeaderFilter />
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={25} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="lotCode" caption="Lot" visible={true} />
                <Column dataField="lotDescription1" caption="Description 1" visible={true} />
                <Column dataField="lotDescription2" caption="Description 2" visible={true} />
                <Column dataField="itemClass" caption="Class" visible={true} />
                <Column dataField="itemSubClass" caption="Sub Class" visible={true} />
                <Column dataField="netAvailable" caption="Net Available" visible={true} />
                <Column dataField="dateIntroduce" caption="Date Introduced" visible={false} />
                <Column dataField="dateAvailable" caption="Date Available" visible={false} />
                <Column dataField="locationCode" caption="Location" visible={false} />
                <Column dataField="lotStatus" caption="Status" visible={false} />
                <Column dataField="lotUDFCode1" caption="Code 1" visible={false} />
                <Column dataField="lotUDFCode2" caption="Code 2" visible={false} />
                <Column dataField="lotUDFCode3" caption="Code 3" visible={false} />
                <Column dataField="lotUDFCode4" caption="Code 4" visible={false} />
                <Column dataField="lotUDFCode5" caption="Code 5" visible={false} />
                <Column dataField="lotUDFCode6" caption="Code 6" visible={false} />
                <Column dataField="lotUDFCode7" caption="Code 7" visible={false} />
                <Column dataField="lotUDFCode8" caption="Code 8" visible={false} />
                <Column dataField="lotUDFCode9" caption="Code 9" visible={false} />
                <Column dataField="lotUDFCode10" caption="Code 10" visible={false} />
                <Column dataField="lotUdfRef1" caption="Reference 1" visible={false} />
                <Column dataField="lotUdfRef2" caption="Reference 2" visible={false} />
                <Column dataField="lotUdfRef3" caption="Reference 3" visible={false} />
                <Column dataField="lotUdfRef4" caption="Reference 4" visible={false} />
                <Column dataField="lotUdfRef5" caption="Reference 5" visible={false} />
                <Column dataField="lotUdfRef6" caption="Reference 6" visible={false} />
                <Column dataField="lotUdfRef7" caption="Reference 7" visible={false} />
                <Column dataField="lotUdfRef8" caption="Reference 8" visible={false} />
                <Column dataField="lotUdfRef9" caption="Reference 9" visible={false} />
                <Column dataField="lotUdfRef10" caption="Reference 10" visible={false} />
                <Column dataField="lotUdfDate1" caption="Date 1" visible={false} />
                <Column dataField="lotUdfDate2" caption="Date 2" visible={false} />
                <Column dataField="lotUdfDate3" caption="Date 3" visible={false} />
                <Column dataField="lotUdfDate4" caption="Date 4" visible={false} />
                <Column dataField="lotUdfDate5" caption="Date 5" visible={false} />
                <Column dataField="lotUdfDate6" caption="Date 6" visible={false} />
                <Column dataField="lotUdfDate7" caption="Date 7" visible={false} />
                <Column dataField="lotUdfDate8" caption="Date 8" visible={false} />
                <Column dataField="lotUdfDate9" caption="Date 9" visible={false} />
                <Column dataField="lotUdfDate10" caption="Date 10" visible={false} />
                <Column dataField="lotUdfQty1" caption="Quantity 1" visible={false} />
                <Column dataField="lotUdfQty2" caption="Quantity 2" visible={false} />
                <Column dataField="lotUdfQty3" caption="Quantity 3" visible={false} />
                <Column dataField="lotUdfQty4" caption="Quantity 4" visible={false} />
                <Column dataField="lotUdfQty5" caption="Quantity 5" visible={false} />
                <Column dataField="lotUdfQty6" caption="Quantity 6" visible={false} />
                <Column dataField="lotUdfQty7" caption="Quantity 7" visible={false} />
                <Column dataField="lotUdfQty8" caption="Quantity 8" visible={false} />
                <Column dataField="lotUdfQty9" caption="Quantity 9" visible={false} />
                <Column dataField="lotUdfQty10" caption="Quantity 10" visible={false} />
                <Column dataField="lotAvailable" caption="Available" visible={false} />
                <Column dataField="lotNetWeightQty" caption="Net Weight Quantity" visible={false} />
                <Column dataField="lotGrossWeightQty" caption="Gross Weight Quantity" visible={false} />
                <Column dataField="lotOnHand" caption="On Hand" visible={false} />
                <Column dataField="lotInReceiving" caption="In Receiving" visible={false} />
                <Column dataField="lotOutShipped" caption="Out Shipped" visible={false} />
                <Column dataField="lotOutUnavailable" caption="Out Unavailable" visible={false} />
                <Column dataField="lotInOrdered" caption="In Ordered" visible={false} />
                <Column dataField="lotOutOrdered" caption="Out Ordered" visible={false} />
                <Column dataField="lotInFuture" caption="In Future" visible={false} />
                <Column dataField="lotOutFuture" caption="Out Future" visible={false} />
                <Column dataField="lotFirstReceipt" caption="First Receipt" visible={false} />
                <Column dataField="dateExpiration" caption="Expiration Date" visible={false} />
                <Column dataField="unitsPerPackageQuantity" caption="Units per Package Quantity" visible={false} />
                <Column dataField="piecesPerUnitUOM" caption="Pieces per Unit UOM" visible={false} />
                <Column dataField="inventoryUnitUOM" caption="Inventory Unit UOM" visible={false} />
                <Column dataField="piecesPerUnitQuantity" caption="Pieces per Unit Quantity" visible={false} />
                <Column dataField="unitsPerPackageUOM" caption="Units per Package UOM" visible={false} />
                <Column dataField="grossWeightUOM" caption="Gross Weight UOM" visible={false} />
                <Column dataField="customerName" caption="Customer Name" visible={false} />
                <Column dataField="customerCode" caption="Customer Code" visible={false} />
                <Column dataField="storageBillingStartDate" caption="Storage Billing Start Date" visible={false} />
                <Column dataField="storageBillingEndDate" caption="Storage Billing End Date" visible={false} />
                <Column dataField="storageBilledDateLast" caption="Storage Billed Date Last" visible={false} />
                <Column dataField="prevStorageBilledDateLast" caption="Prev Storage Billed Date Last" visible={false} />
                <Column dataField="storageBilledDateNext" caption="Storage Billed Date Next" visible={false} />
                <Column dataField="prevStoragebBilledDateNext" caption="Prev Storage Billed Date Next" visible={false} />
                <Column dataField="itemCode" caption="Item Code" visible={false} />
                <Column dataField="itemDescription1" caption="Item Description 1" visible={false} />
                <Column dataField="itemDescription2" caption="Item Description 2" visible={false} />
                <Column dataField="itemStatus" caption="Item Status" visible={false} />
                <Column dataField="itemClass" caption="Item Class" visible={false} />
                <Column dataField="itemSubClass" caption="Item Sub Class" visible={false} />
                <Column dataField="itemType" caption="Item Type" visible={false} />
                <Column dataField="Department" caption="Department" visible={false} />
                <Column dataField="DepartmentDescription" caption="Department Description" visible={false} />
                <Column dataField="Job" caption="Job" visible={false} />
                <Column dataField="JobDescription" caption="Job Description" visible={false} />
                <Column dataField="Fund" caption="Fund" visible={false} />
                <Column dataField="FundDescription" caption="Fund Description" visible={false} />
                <Toolbar>

                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LotByItemSubTab);